// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';

const StyledSection = styled.section`
  width: 100%;
  box-sizing: border-box;
`;

const Section = {
  label: 'Section',
  fields: {
    anchorId: {
      type: 'text',
      label: 'Anchor name',
    },
    backgroundColor: {
      type: 'text',
      label: 'Background color',
    },
    fullHeight: {
      type: 'radio',
      label: 'Full height',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    verticalAlign: {
      type: 'radio',
      label: 'Vertical align',
      options: [
        { label: 'Top', value: 'top' },
        { label: 'Center', value: 'center' },
        { label: 'Bottom', value: 'bottom' },
      ],
    },
    paddingTop: {
      type: 'select',
      label: 'Padding top',
      options: [
        { label: 'None', value: '0' },
        { label: 'Small', value: '1rem' },
        { label: 'Medium', value: '2rem' },
        { label: 'Large', value: '4rem' },
        { label: 'Extra large', value: '6rem' },
      ],
    },
    paddingBottom: {
      type: 'select',
      label: 'Padding bottom',
      options: [
        { label: 'None', value: '0' },
        { label: 'Small', value: '1rem' },
        { label: 'Medium', value: '2rem' },
        { label: 'Large', value: '4rem' },
        { label: 'Extra large', value: '6rem' },
      ],
    },
    paddingLeft: {
      type: 'select',
      label: 'Padding left',
      options: [
        { label: 'None', value: '0' },
        { label: 'Small', value: '1rem' },
        { label: 'Medium', value: '2rem' },
        { label: 'Large', value: '4rem' },
        { label: 'Extra large', value: '6rem' },
      ],
    },
    paddingRight: {
      type: 'select',
      label: 'Padding right',
      options: [
        { label: 'None', value: '0' },
        { label: 'Small', value: '1rem' },
        { label: 'Medium', value: '2rem' },
        { label: 'Large', value: '4rem' },
        { label: 'Extra large', value: '6rem' },
      ],
    },
    content: { type: 'slot' },
  },
  defaultProps: {
    anchorId: '',
    backgroundColor: '#ffffff',
    fullHeight: false,
    verticalAlign: 'top',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    paddingLeft: '2rem',
    paddingRight: '2rem',
    content: [],
  },
  render: ({ anchorId, backgroundColor, fullHeight, verticalAlign, paddingTop, paddingBottom, paddingLeft, paddingRight, content: Content }) => {
    const alignMap = { top: 'flex-start', center: 'center', bottom: 'flex-end' };
    const normalizedAnchorId = anchorId?.trim().replace(/^#+/, '').replace(/\s+/g, '-');
    return (
      <StyledSection
        id={ normalizedAnchorId || undefined }
        style={ {
          backgroundColor,
          paddingTop,
          paddingBottom,
          paddingLeft,
          paddingRight,
          ...(fullHeight ? { height: '100%', display: 'flex', flexDirection: 'column', justifyContent: alignMap[verticalAlign] } : {}),
        } }
      >
        <Content />
      </StyledSection>
    );
  },
};

// eslint-disable-next-line import/prefer-default-export
export { Section };
